import React from 'react'
import PropTypes from 'prop-types'
import ExceptionContainer from './ExceptionContainer.js'
import AccessDate from './AccessDate.js'
import DueDate from './DueDate.js'
import TimeLimit from './TimeLimit.js'
import { studentExceptions as endpoints } from '../../api_urls'
import { client } from '../../utils'
import moment from 'moment'

class StudentExceptions extends React.Component {
  constructor(props) {
    super()
    this.state = {
      accessDate: {
        exists: false,
        available: true,
        accessDate: null,
        invisible: false,
        ...props.accessData,
        saved: true,
        errorMessage: null,
      },
      dueDate: {
        exists: false,
        dueDate: null,
        lateAction: 'flag',
        deductions: [
          {
            deductNum: 1,
            deductType: 'point',
            timeNum: 1,
            timeType: 'm',
          },
        ],
        ...props.lateData,
        saved: true,
        errorMessage: null,
      },
      timeLimit: {
        exists: false,
        timeLimit: 5,
        lateAction: 'flag',
        deductions: [
          {
            deductNum: 1,
            deductType: 'point',
            timeNum: 1,
            timeType: 'm',
          },
        ],
        ...props.timeData,
        saved: true,
        errorMessage: null,
      },
    }
  }

  postException = (url, data) => {
    return client({
      method: 'post',
      data: data,
      url: url,
      config: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  prepDeductions = deductions => {
    let ded = deductions.map(value => {
      let ret = []
      ret[0] = value.timeNum
      ret[1] = value.timeType
      ret[2] = value.deductNum
      ret[3] = value.deductType
      return ret
    })
    return JSON.stringify(ded)
  }

  onSave = async () => {
    if (!this.state.accessDate.saved) {
      let url = endpoints.postAccessDate({
        activityId: this.props.activityPK,
        studentId: this.props.studentPK,
      })
      let formData = new FormData()
      let date = moment(this.state.accessDate.accessDate).format(
        'YYYY-MM-DD HH:mm:ss'
      )

      formData.append('exists', this.state.accessDate.exists)
      if (this.state.accessDate.exists) {
        formData.append('available', this.state.accessDate.available)
        if (!this.state.accessDate.available) {
          formData.append('visible', !this.state.accessDate.invisible)
          formData.append('access_date', date)
        }
      }

      this.postException(url, formData).then(
        () => {
          this.setState({
            accessDate: {
              ...this.state.accessDate,
              saved: true,
              errorMessage: null,
            },
          })
        },
        e => {
          let errors = ''
          for (var error in e.response.data.errors) {
            errors += e.response.data.errors[error]
          }
          this.setState({
            accessDate: { ...this.state.accessDate, errorMessage: errors },
          })
        }
      )
    }

    if (!this.state.dueDate.saved) {
      let url = endpoints.postDueDate({
        activityId: this.props.activityPK,
        studentId: this.props.studentPK,
      })
      let formData = new FormData()
      let date = moment(this.state.dueDate.dueDate).format(
        'YYYY-MM-DD HH:mm:ss'
      )

      formData.append('exists', this.state.dueDate.exists)
      if (this.state.dueDate.exists) {
        formData.append('action', this.state.dueDate.lateAction)
        formData.append(
          'deductions',
          this.prepDeductions(this.state.dueDate.deductions)
        )
        formData.append('due_date', date)
      }

      this.postException(url, formData).then(
        () => {
          this.setState({
            dueDate: { ...this.state.dueDate, saved: true, errorMessage: null },
          })
        },
        e => {
          let errors = ''
          for (var error in e.response.data.errors) {
            errors += e.response.data.errors[error]
          }
          this.setState({
            dueDate: { ...this.state.dueDate, errorMessage: errors },
          })
        }
      )
    }

    if (!this.state.timeLimit.saved) {
      let url = endpoints.postTimeLimit({
        activityId: this.props.activityPK,
        studentId: this.props.studentPK,
      })
      let formData = new FormData()

      formData.append('exists', this.state.timeLimit.exists)
      if (this.state.timeLimit.exists) {
        formData.append('action', this.state.timeLimit.lateAction)
        formData.append(
          'deductions',
          this.prepDeductions(this.state.timeLimit.deductions)
        )
        formData.append('time_limit', this.state.timeLimit.timeLimit)
      }

      this.postException(url, formData).then(
        () => {
          this.setState({
            timeLimit: {
              ...this.state.timeLimit,
              saved: true,
              errorMessage: null,
            },
          })
        },
        e => {
          let errors = ''
          for (var error in e.response.data.errors) {
            errors += e.response.data.errors[error]
          }
          this.setState({
            timeLimit: { ...this.state.timeLimit, errorMessage: errors },
          })
        }
      )
    }
  }

  onAccessDateChange = (key, value) => {
    this.setState({
      accessDate: {
        ...this.state.accessDate,
        [key]: value,
        saved: false,
      },
    })
  }

  onDueDateChange = (key, value) => {
    this.setState({
      dueDate: {
        ...this.state.dueDate,
        [key]: value,
        saved: false,
      },
    })
  }

  onTimeLimitChange = (key, value) => {
    this.setState({
      timeLimit: {
        ...this.state.timeLimit,
        [key]: value,
        saved: false,
      },
    })
  }

  render() {
    return (
      <div className="d-flex flex-column justify-content-around align-items-center minh-300px mt-4">
        <h1 className="text-center"> Student Exceptions </h1>
        <h4 className="text-center"> {this.props.activityTitle}</h4>
        <div>
          {' '}
          Create Exceptions for {this.props.studentName} (
          {this.props.studentEmail})
        </div>
        <ExceptionContainer
          title="Access Date"
          icon="calendar"
          ruleExists={this.state.accessDate.exists}
          updateExists={value => this.onAccessDateChange('exists', value)}
          saved={this.state.accessDate.saved}
          errorMessage={this.state.accessDate.errorMessage}
        >
          <AccessDate
            dateValue={this.state.accessDate.accessDate}
            onDateChange={date => this.onAccessDateChange('accessDate', date)}
            available={this.state.accessDate.available}
            onAvailableChange={() =>
              this.onAccessDateChange(
                'available',
                !this.state.accessDate.available
              )
            }
            invisible={this.state.accessDate.invisible}
            onInvisibleChange={() =>
              this.onAccessDateChange(
                'invisible',
                !this.state.accessDate.invisible
              )
            }
          />
        </ExceptionContainer>
        <ExceptionContainer
          title="Due Date"
          icon="calendar-check"
          ruleExists={this.state.dueDate.exists}
          updateExists={value => this.onDueDateChange('exists', value)}
          saved={this.state.dueDate.saved}
          errorMessage={this.state.dueDate.errorMessage}
        >
          <DueDate
            dateValue={this.state.dueDate.dueDate}
            onDateChange={value => this.onDueDateChange('dueDate', value)}
            lateAction={this.state.dueDate.lateAction}
            onLateRuleChange={value =>
              this.onDueDateChange('lateAction', value)
            }
            deductions={this.state.dueDate.deductions}
            onDeductionsChange={value =>
              this.onDueDateChange('deductions', value)
            }
          />
        </ExceptionContainer>
        <ExceptionContainer
          title="Time Limit"
          icon="clock"
          ruleExists={this.state.timeLimit.exists}
          updateExists={value => this.onTimeLimitChange('exists', value)}
          saved={this.state.timeLimit.saved}
          errorMessage={this.state.timeLimit.errorMessage}
        >
          <TimeLimit
            lateAction={this.state.timeLimit.lateAction}
            onLateRuleChange={value =>
              this.onTimeLimitChange('lateAction', value)
            }
            timeLimit={this.state.timeLimit.timeLimit}
            onTimeLimitChange={value =>
              this.onTimeLimitChange('timeLimit', value)
            }
            deductions={this.state.timeLimit.deductions}
            onDeductionsChange={value =>
              this.onTimeLimitChange('deductions', value)
            }
          />
        </ExceptionContainer>
        <button className="btn btn-dark-blue" onClick={this.onSave}>
          <span className="fa-solid fa-save fa-fw" /> Save{' '}
        </button>
      </div>
    )
  }
}

StudentExceptions.propTypes = {
  activityPK: PropTypes.string,
  activityTitle: PropTypes.string,
  coursenum: PropTypes.string,
  studentPK: PropTypes.string,
  studentName: PropTypes.string,
  studentEmail: PropTypes.string,
  accessData: PropTypes.object,
  lateData: PropTypes.object,
  timeData: PropTypes.object,
}

export default StudentExceptions
